import React from 'react';
import { Button, Paper, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Link } from 'react-router-dom';

import { book } from '../../routers/books';
import { useGetJobsAccountHomeQuery } from '../../services/serviceJobsAccount';

export const ResumeDatabaseUpsell = ({
  onShowRequests,
}: {
  onShowRequests?: () => void;
}) => {
  const account = useGetJobsAccountHomeQuery();
  const canManageListings = Boolean(account.data?.hasListings);

  return (
    <Paper variant="outlined" sx={{ borderRadius: 0, boxShadow: '6px 6px 0 var(--accent-soft)', mx: 'auto', my: 5, p: { xs: 3, md: 5 }, maxWidth: 760, textAlign: 'center' }}>
      <LockOutlinedIcon sx={{ color: 'var(--accent-text)', fontSize: 52 }} />
      <Typography component="h2" variant="h4" sx={{ my: 2 }}>An active Featured listing unlocks Resume Database access</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        {account.data && !canManageListings
          ? 'A listing owner must post or upgrade a Featured listing to unlock this. Reviewing applicants does not include listing or billing controls.'
          : 'Find experienced CPG candidates. Searchable profiles keep identity and contact details hidden until the candidate approves your request.'}
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
        {canManageListings ? (
          <>
            <Button component={Link} to={book.postAJob} variant="contained">Post a Featured job</Button>
            <Button component={Link} to={book.jobsListings} variant="outlined">Upgrade an existing listing</Button>
          </>
        ) : null}
        {onShowRequests ? <Button variant="text" onClick={onShowRequests}>View my contact requests</Button> : null}
      </Stack>
    </Paper>
  );
};

export default ResumeDatabaseUpsell;
